import { render } from "./ContractsPaymentsTab.vue?vue&type=template&id=703fc075&scoped=true"
import script from "./ContractsPaymentsTab.vue?vue&type=script&lang=js"
export * from "./ContractsPaymentsTab.vue?vue&type=script&lang=js"

import "./ContractsPaymentsTab.vue?vue&type=style&index=0&id=703fc075&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703fc075"]])

export default __exports__